import styled from 'styled-components';
import colors from '../../assets/colors';

export const Content = styled.div`
  display: flex;
  flex-wrap: wrap;

  .row {
    flex: 1;
    max-width: 370px;
    min-width: 370px;
    
    .container {
      display: flex;
      padding: 30px;
      background-color: ${colors.white};
      border-radius: 8px;
      -webkit-box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
      -moz-box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
      box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);

      .content {
        flex: 1;

        h2 {
          font-size: 0.95rem;
          text-transform: uppercase;
          font-weight: 700;
          color: #000;
        }

        h3 {
          font-size: 1.6rem;
          font-weight: 700;
          color: ${colors.primary};
          padding: 8px 0;

          span {
            padding-right: 5px;
            font-weight: 300;
          }
        }

        .fa-star {
          padding: 10px 6px 10px 0;
          font-size: 1.2rem;
          color: ${colors.primary};
        }

        p {
          font-size: 0.9rem;
          letter-spacing: -0.5px;
          color: #B5B5B5;
        }
      }

      button {
        width: 105px;
        height: 35px;
        padding: 0;
        margin-left: 15px;
        background: none;
        border-radius: 100px;
        border: 2px solid ${colors.primary};
        outline: none;
        cursor: pointer;

        a, span {
          font-family: 'Open Sans', sans-serif;
          text-transform: uppercase;
          text-decoration: none;
          color: ${colors.primary};
          font-size: 0.9rem;
          font-weight: 600;
          letter-spacing: -0.5px;
        }

        :hover { opacity: .9; }
      }
    }

    .progress-container {
      h2 {
        font-size: 1.25rem;
        text-transform: uppercase;
        font-weight: 700;
        color: #000;
      }

      p { color: #999; }
      
      .content {
        height: 201px;
        padding: 30px;
        margin: 20px 0 30px;
        background-color: #E9E9E9;
        border-radius: 8px;
        box-shadow: inset 0 0 5px 0 rgba(0, 0, 0, 0.2);

        .in-progress {
          position: relative;
          top: -200px;
          opacity: 0.15;
        }

        .progress-complete {
          position: relative;
          z-index: 10;
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100%;

          button {
            width: 200px;
            padding: 11px 0;
            background: ${colors.primary};
            background: linear-gradient(180deg, rgba(55,205,63,1) 0%, rgba(41,157,44,1) 100%);
            border: none;
            border-radius: 100px;
            text-transform: uppercase;
            font-size: 0.9rem;
            font-weight: 600;
            color: ${colors.white};
            font-family: 'Open Sans', sans-serif;
            outline: none;
            cursor: pointer;

            :hover { opacity: .9 }
          }
        }
      }

      .steps {
        margin-top: 25px;

        .item {
          display: flex;
          padding-bottom: 12px;

          .fa-check-circle {
            font-size: 1.1rem;
            color: ${colors.primary};
            margin-top: 1px;
            margin-right: 10px;
          }

          .uncheck-circle {
            width: 19px;
            height: 19px;
            background: #F9F9F9;
            border-radius: 10px;
            margin-top: 1px;
            margin-right: 10px;
          }

          p {
            font-size: 0.9rem;
            color: #777;
          }
        }
      }
    }

    :first-child { margin-right: 30px; }
  }

  .chart {
    max-width: 770px !important;
    min-width: 600px;
    
    .container {
      flex-direction: column;
      height: 270px;

      .head {
        display: flex;
        flex-direction: space-between;
        align-items: center;
        padding-bottom: 25px;

        h2, span {
          flex: 1;
          font-size: 0.95rem;
          text-transform: uppercase;
          font-weight: 700;
          color: #000;
        }

        .fa-circle {
          color: ${colors.primary};
          font-size: 0.55rem;
          padding: 6px 6px 4px;
        }

        .label {
          color: ${colors.primary};
          font-size: 0.9rem;
          letter-spacing: -0.5px;
        }
      }

      .custom-tooltip {
        padding: 10px;
        background: #FFF;
        border-radius: 8px;
        border: 1px solid #DDDDDD;
        -webkit-box-shadow: 0px 0px 5px 2px rgba(0,0,0,0.05);
        -moz-box-shadow: 0px 0px 5px 2px rgba(0,0,0,0.05);
        box-shadow: 0px 0px 5px 2px rgba(0,0,0,0.05);
        font-size: 0.9rem;

        .month { font-weight: 700; color: ${colors.primary}; }
      }
      
      text, .recharts-legend-item-text { font-size: 0.9rem; fill: #B5B5B5; }
    }
  }

  @media screen and (max-width: 374px) {
    .row .container { 
      flex-direction: column;

      button { 
        margin-top: 15px;
        margin-left: 0;
      }
    }
  }

  @media screen and (max-width: 1056px) {
    flex-direction: column;

    .row {
      max-width: 100% !important;
      min-width: 200px !important;

      .container { padding: 20px; }
    }

    .chart {
      margin-right: 0 !important;

      .container { height: 320px; }
    }

    .progress-container .content { padding: 20px !important; }

    .container { margin-bottom: 20px !important; }
  }
`;

export const ProgressBar = styled.div`
  height: 26px;
  padding: 5px;
  background-color: #FFF;
  border-radius: 5px;

  .percentage {
    position: relative;
    top: -25px;
    width: ${props => `${props.percent}%`};
    height: 22px;
    padding: 2px 0;
    background-color: ${colors.primary};
    border-radius: 5px;
  }

  .pecent-value {
    position: relative;
    z-index: 10;
    padding: 3px 0;
    font-size: 0.85rem;
    font-weight: 700;
    color: #004E03;
    text-align: center;
  }
`;
